import { useEffect } from 'react';
import { SignInForm } from 'core/components/SignInForm';
import { getCurrentUser } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

/** ログイン画面全体のコンポーネント。 */
export const SignIn = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        navigate('/jian-list');
      } catch {
        navigate('/');
      }
    };
    checkAuth();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <SignInForm />
    </div>
  );
};
